import React, { Component } from 'react';
import networkList from '../../../../constants/networkList';
// import ProfileSchema from '../../../schema/counsellor-profile';
// import Inputlayer from '../../../components/FormComponent/Input';
// import { filter, formData, dissableFormData } from '../../../schema/apppointment';
const $ = require('jquery');
const {homepage} = networkList;
class User_Details extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render() {
        return (

            <div className="card p-5 m-5">
               <div className="pb-5">
               <h1 className="text-heading float-left pl-3">Abhishek Chowdhury</h1>
               <a href="#"  className="float-right" style={{'color':'#455a64'}}>Edit <img src={homepage+"/assets/images/icons/edit.png"}/></a>
               </div>
                <div className="row mx-auto pb-5">
                    <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                        <p className="data-label">DOB</p>
                        <p className="data-item">: 31st March 1990</p>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                        <p className="data-label">Gender</p>
                        <p className="data-item">: Male</p>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                        <p className="data-label">Phone</p>
                        <p className="data-item">: 9999999999</p>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                        <p className="data-label">Unit</p>
                        <p className="data-item">: Kondapur, KIMS</p>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                        <p className="data-label">Role</p>
                        <p className="data-item">: Counsellor</p>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                        <p className="data-label">User ID</p>
                        <p className="data-item">: arckondapur</p>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <button className="btn btn-success text-capitalize mr-3">Activate User</button>
                    <button className="btn btn-success btn-next text-capitalize">cancel</button>
                </div>
            </div>

        )

    }
}
export default User_Details;